import './App.css';
import { createBrowserRouter, Navigate, RouterProvider } from 'react-router-dom';
import Login from './component/Login/Login';
import Layout from './component/Layout/Layout';
import Home from './component/Home/Home';
import Register from './component/Register/Register';
import ChangePassword from './component/ChangePassword/ChangePassword';
import ResetPassword from './component/ResetPassword/ResetPassword';
import ForgetPassword from './component/ForgetPassword/ForgetPassword';
import AccountType from './component/AccountType/AccountType';
import Admin from './component/Admin/Admin';
import Services from './component/Services/Services';
import RelatedProducts from './component/RelatedProducts/RelatedProducts';
import RelatedActivites from './component/RelatedActivites/RelatedActivites';
import SidebarFilters from './component/SidebarFilters/SidebarFilters';
import ProductList from './component/ProductList/ProductList';
import ProductCard from './component/ProductCard/ProductCard';
import MyStore from './component/MyStore/MyStore';
import NewOrders from './component/NewOrders/NewOrders';
import NewOrders2 from './component/NewOrders2/NewOrders2';
import NewordersDetails from './component/NewordersDetails/NewordersDetails';
// import CanceledOrders from './component/CanceledOrders/CanceledOrders';
import CanceledOrdersDetails from './component/CanceledOrdersDetails/CanceledOrdersDetails';
import ProductDetails from './component/ProductDetails/ProductDetails';
import SellerProductDetails from './component/SellerProductDetails/SellerProductDetails';

import AddAdvertisement from './component/AddAdvertisement/AddAdvertisement';

import FinancialReports from './component/FinancialReports/FinancialReports';
import MysecodStore from './component/MysecodStore/MysecodStore';
import AdverisementDetails from './component/AdvertisementDetails/AdvertisementDetails';
import MyOrders from './component/MyOrders/MyOrders';
import ConfirmedOrders from './component/ConfirmedOrders/ConfirmedOrders';
import OrderDetails from './component/OrderDetails/OrderDetails';
// import ShippedOrders from './component/ShippedOrders/ShippedOrders';
import OrdersDetails2 from './component/OrdersDetails2/OrdersDetails2';
import MyemptydeiveredOrders from './component/MyemptydeiveredOrders/MyemptydeiveredOrders';
import MydeliveredOrders from './component/MydeliveredOrders/MydeliveredOrders';
import Marketing from './component/Marketing/Marketing';
import ProfileAccount from './component/ProfileAccount/ProfileAccount';
import MarketingReferral from './component/MarketingReferral/MarketingReferral';
import LogoutConfirm from './component/LogoutConfirm/LogoutConfirm';
import ContractPage from './component/ContractPage/ContractPage';
import SecondContract from './component/SecondContract/SecondContract';
import BankAccount from './component/BankAccount/BankAccount';
import EmptyAdvertisement from './component/EmptyAdvertisement/EmptyAdvertisement';
import MoreRelated from './component/MoreRelated/MoreRelated'
import ChooseSupport from './component/ChooseSupport/ChooseSupport';
// import MaddiSupport from './component/MaddiSupport/MaddiSupport';
import MyOrdDetails from './component/MyOrdDetails/MyOrdDetails'
import Categories from './component/Categories/Categories';
import ProductsSection from './component/ProductsSection/ProductsSection';
import CategoryFilter from './component/CategoryFilter/CategoryFilter';
import CategoryPage from './component/CategoryPage/CategoryPage';
import Shopping from './component/Shopping/Shopping';
import ConfirmedOrdersDetails from './component/ConfirmOrdersDetails/ConfirmOrdersDetails';
import Orders from './component/Orders/Orders';
import PaymentPage from './component/PaymentPage/PaymentPage';
import EyeSupport from './component/EyeSupport/EyeSupport';
import FinancialSupport from './component/FinancialSupport/FinancialSupport';
import EyeSuccess from './component/EyeSuccess/EyeSuccess';
import FinancialSuccess from './component/FinancialSuccess/FinancialSuccess';
import Favorites from './component/Favorites/Favorites';
import CategoryDetails from './component/CategoryDetails/CategoryDetails';
//  import OfferTawq from './component/OfferTawq/OfferTawq';
import FSuccess from './component/FSuccess/FSuccess';
import ProductsFurniture from './component/ProductsFurniture/ProductsFurniture';
import ProductsKitchen from './component/ProductsKitchen/ProductsKitchen';
import CategoriesSlider from './component/CategoriesSlider/CategoriesSlider';
import Abouttawq from './component/Abouttawq/Abouttawq';
//saller//
import SellerLogin from './component/SellerLogin/SellerLogin';
import SellerLayout from './component/SellerLayout/SellerLayout';
import SellerHome from './component/SellerHome/SellerHome';
import SellerRegister from './component/SellerrRegister/SellerrRegister';
import SellerChangePassword from './component/SellerChangePassword/SellerChangePassword';
import SellerResetPassword from './component/SellerResetPassword/SellerResetPassword';
import SellerForgetPassword from './component/SellerForgetPassword/SellerForgetPassword';
import SellerAccountType from './component/SellerAccountType/SellerAccountType';
import SellerAdmin from './component/SellerAdmin/SellerAdmin';
import SellerServices from './component/SellerServices/SellerServices';
import SellerRelatedProducts from './component/RelatedProducts/RelatedProducts';
import SellerRelatedActivites from './component/RelatedActivites/RelatedActivites';
import SellerSidebarFilters from './component/SidebarFilters/SidebarFilters';
import SellerProductList from './component/ProductList/ProductList';
import SellerProductCard from './component/ProductCard/ProductCard';
import SellerNewOrders from './component/SellerNewOrders/SellerNewOrders';
import SellerNewOrders2 from './component/SellerNewOrders2/SellerNewOrders2';
import SellerNewordersDetails from './component/SellerNewordersDetails/SellerNewordersDetails';
import SellerCanceledOrders from './component/SellerCanceledOrders/SellerCanceledOrders';
import SellerCanceledOrdersDetails from './component/SellerCanceledOrdersDetails/SellerCanceledOrdersDetails';
// import SellerProductDetails from './component/SellerProductDetails/SellerProductDetails';
import SellerAddAdvertisement from './component/SellerAddAdvertisement/SellerAddAdvertisement';
import SellerFinancialReports from './component/SellerFinancialReports/SellerFinancialReports';
import SellerMysecodStore from './component/SellerMysecodStore/SellerMysecodStore';
import SellerAddverisementDetails from './component/SellerAdvertisementDetails/SellerAdvertisementDetails';
import SellerMyOrders from './component/SellerMyOrders/SellerMyOrders';
import SellerConfirmedOrders from './component/SellerConfirmedOrders/SellerConfirmedOrders';
import SellerOrderDetails from './component/SellerOrderDetails/SellerOrderDetails';
import SellerShippedOrders from './component/SellerShippedOrders/SellerShippedOrders';
import SellerOrdersDetails2 from './component/SellerOrdersDetails2/SellerOrdersDetails2';
import SellerMyemptydeiveredOrders from './component/SellerMyemptydeiveredOrders/SellerMyemptydeiveredOrders';
import SellerMydeliveredOrders from './component/SellerMydeliveredOrders/SellerMydeliveredOrders';
import SellerMarketing from './component/SellerMarketing/SellerMarketing';
import SellerProfileAccount from './component/SellerProfileAccount/SellerProfileAccount';
import SellerMarketingReferral from './component/SellerMarketingReferral/SellerMarketingReferral';
import SellerLogoutConfirm from './component/SellerLogoutConfirm/SellerLogoutConfirm';
import SellerContractPage from './component/SellerContractPage/SellerContractPage';
import SellerSecondContract from './component/SellerSecondContract/SellerSecondContract';
import SellerBankAccount from './component/SellerBankAccount/SellerBankAccount';
import SellerEmptyAdvertisement from './component/SellerEmptyAdvertisement/SellerEmptyAdvertisement';
import SellerMoreRelated from './component/SellerMoreRelated/SellerMoreRelated';
import SellerChooseSupport from './component/SellerChooseSupport/SellerChooseSupport';
import SellerAyniSupport from './component/SellerAyniSupport/SellerAyniSupport';
import SellerMaddiSupport from './component/SellerMaddiSupport/SellerMaddiSupport';
import SellerMyOrdDetails from './component/SellerMyOrdDetails/SellerMyOrdDetails';
import SellerFinancialDashboard from './component/SellerFinancialDashboard/SellerFinancialDashboard';
import SellerProductsSection from './component/SellerProductsSection/SellerProductsSection';
import SellerAbouttawq from './component/SellerAbouttawq/SellerAbouttawq';
import Offerstawqnajah from './component/Offerstawqnajah/Offerstawqnajah';
import OffersTawq from './component/OffersTawq/OffersTawq';
import CommunityPartnerships from './component/CommunityPartnerships/CommunityPartnerships';
import Marketers from './component/Marketers/Marketers';
import SuccessPartners from './component/SuccessPartners/SuccessPartners';
import Sellers from './component/Sellers/Sellers';
import SellersDetails from './component/SellersDetails/SellersDetails';
import AllOffers from './component/AllOffers/AllOffers';
import AllProductsByCategory from './component/AllProductsByCategory/AllProductsByCategory';
import Privacy from './component/Privacy/Privacy';
import ScrollTop from './component/ScrollTop/ScrollTop'
import ConfirmOrderDetails from './component/ConfirmOrdersDetails/ConfirmOrdersDetails';
import ShippedOrderDetails from './component/ShippedOrdersDetails/ShippedOrdersDetails';
import SellerConfirmdOrdersDetails from './component/SellerConfirmedOrdersDetails/SellerConfirmedOrdersDetails';
import SellerShippedOrderDetails from './component/SellerShippedOrdersDetails/SellerShippedOrdersDetails';
import SellerDiscountsDetails from './component/SellerDiscountsDetails/SellerDiscountsDetails';
import WinterjacketDetails from './component/WinterjacketDetails/WinterjacketDetails';
import SellerBurgerOffer from './component/SellerBurgerOffer/SellerBurgerOffer';
import SellerMobileOffer from './component/SellerMobileOffer/SellerMobileOffer';
import SellerMyStore from './component/SellerMyStore/SellerMyStore';
import Offers from './component/Offers/Offers';
import OffersSugg from './component/OffersSugg/OffersSugg'
import WinterDetails from './component/WinterDetails/WinterDetails';
import Slider from './component/Slider/Slider';
import SellerUppernav from './component/SellerUppernav/SellerUppernav';
import OffersDetails from './component/OffersDetails/OffersDetails';
import Myaddvertisements from './component/Myaddvertisements/Myaddvertisements';
import SellerPrivacy from './component/SellerPrivacy/SellerPrivacy';
import SellereSupport from './component/SellereSupport/SellereSupport';
import SellerFinancialSupport from './component/SellerFinancialSupport/SellerFinancialSupport';
import SellerTerms from './component/SellerTerms/SellerTerms';
import SellerFooter from './component/SellerFooter/SellerFooter';
import PrivateRoute from './component/PrivateRoue';
import Otp from './component/Otp/Otp';
import SellerOtp from './component/SellerOtp/SellerOtp';
import Cart from './component/Cart/Cart';
import SellerRelatedProductsWrapper from './component/SellerRelatedProductsWrapper/SellerRelatedProductsWrapper';
import CategoryProducts from './component/CategoryProducts/CategoryProducts';
import SuggList from './component/SuggList/SuggList';
import SellerStoreDetails from './component/SellerStoreDetails/SellerStoreDetails';
import Notification from './component/Notification/Notification';
import SellerNotifications from './component/SellerNotifications/SellerNotifications';
import SellerReg2 from './component/SellerReg2/SellerReg2';
import OfferstawqBreif from './component/OfferstawqBreif/OfferstawqBreif';
import Terms from './component/Terms/Terms';
import { useEffect } from "react";
import { getMyToken } from "./getToken";
import { getToken, onMessage } from "firebase/messaging";
import { messaging } from "./firebase";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PaymentResult from './component/PaymentResult/PaymentResult';
import EditAdvertisement from './component/EditAdvertisement/EditAdvertisement';
export const BaseUrl = "https://api.tokalnaja.com/api/";
const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    children: [

     {
  index: true,
  element: <Home />,
},
{ path: 'home', element: <Home /> },

      { path: 'login', element: <Login /> },
      { path: 'neworders2', element: <NewOrders2 /> },
      {path:'notification' ,element: <Notification/>},
      { path: 'newordersdetails', element: <NewordersDetails /> },
      { path: 'changepassword', element: <ChangePassword /> },
      { path: 'forgetpassword', element: <ForgetPassword /> },
      { path: 'resetpassword', element: <ResetPassword /> },
      { path: 'register', element: <Register /> },
      { path: 'accounttype', element: <AccountType /> },
      { path: 'admin', element: <Admin /> },
      { path: 'services', element: <Services /> },
      { path: 'relatedproducts', element: <RelatedProducts /> },
      { path: 'relatedactivites', element: <RelatedActivites /> },
      { path: 'sidebarfilters', element: <SidebarFilters /> },
      { path: 'productlist', element: <ProductList /> },
      { path: 'productcard', element: <ProductCard /> },
      { path: 'productdetails/:id', element: <ProductDetails /> },
      { path: 'sellerproductdetails/:id', element: <SellerProductDetails/> },

      // { path: 'canceledorders', element: <CanceledOrders /> },
      { path: 'mystore', element: <MyStore /> },
      { path: 'neworders', element: <NewOrders /> },
      { path: 'canceledordersdetails', element: <CanceledOrdersDetails /> },
      { path: 'addadvertisement', element: <AddAdvertisement /> },
{ path: "editad/:id", element: <EditAdvertisement /> },
      { path: 'financialreports', element: <FinancialReports /> },
      { path: 'mysecondstore', element: <MysecodStore /> },
      { path: 'advertisementdetails/:id', element: <AdverisementDetails /> },
      { path: 'myorders', element: <MyOrders /> },
//       { path: 'confirmedorders', element:<PrivateRoute> <ConfirmedOrders /></PrivateRoute> },
// { path: 'confirmedorders', element: <ConfirmedOrders defaultStatus="pending" /> },

// { path: 'shippedorders', element: <ConfirmedOrders defaultStatus="completed" /> },
// { path: 'canceledorders', element: <ConfirmedOrders defaultStatus="cancel" /> },
{
  path: 'confirmedorders',
  element: <ConfirmedOrders defaultStatus="pending" />
},
{
  path: 'shippedorders',
  element: (
    <PrivateRoute>
      <ConfirmedOrders defaultStatus="completed" />
    </PrivateRoute>
  )
},
{
  path: 'canceledorders',
  element: (
    <PrivateRoute>
      <ConfirmedOrders defaultStatus="cancel" />
    </PrivateRoute>
  )
},
      { path: 'confirmordersdetails/:id', element: <ConfirmOrderDetails /> },
      { path: 'orderdetails', element: <OrderDetails /> },
      // { path: 'shippedorders', element: <ShippedOrders /> },
      { path: 'shippedordersdetails', element: <ShippedOrderDetails /> },
      { path: 'ordersdetails2', element: <OrdersDetails2 /> },
      { path: 'myemptydeiveredorders', element: <MyemptydeiveredOrders /> },
      { path: 'mydeliveredorders', element: <MydeliveredOrders /> },
      { path: 'marketing', element: <Marketing /> },
      { path: 'profileaccount', element:<PrivateRoute> <ProfileAccount /></PrivateRoute> },
      { path: 'marketingreferral', element: <MarketingReferral /> },
      { path: 'logoutconfirm', element: <LogoutConfirm /> },
      { path: 'contractpage', element: <ContractPage /> },
      { path: 'secondcontract', element: <SecondContract /> },
      { path: 'bankaccount', element: <BankAccount /> },
      { path: 'emptyadvertisement', element: <EmptyAdvertisement /> },
      { path: 'choosesupport', element: <ChooseSupport /> },
      { path: 'communitypartnerships', element: <CommunityPartnerships /> },
      // { path: 'privateroute', element: <PrivateRoute /> },
      // { path: 'maddisupport', element: <MaddiSupport /> },     
      { path: 'marketers', element: <Marketers /> },
      { path: 'eyesupport', element: <PrivateRoute><EyeSupport /></PrivateRoute> },
      { path: 'myorddetails', element: <MyOrdDetails /> },
      { path: 'categories', element: <Categories /> },
      { path: 'productssection', element: <ProductsSection /> },
      { path: 'categoryfilter', element: <CategoryFilter /> },
      { path: 'categorypage', element: <CategoryPage /> },
      { path: 'otp', element: <Otp /> },
      {path: 'sugglist' ,element:<SuggList/>},
      { path: 'shopping', element: <Shopping /> },
      { path: 'orders', element: <Orders /> },
      { path: 'payment', element: <PaymentPage /> },
      {path:"payment-result" ,element:<PaymentResult/>},
      { path: 'financialsupport', element:<PrivateRoute><FinancialSupport /></PrivateRoute>  },
      { path: 'eyesuccess', element:<PrivateRoute><EyeSuccess /></PrivateRoute>  },
      { path: 'financialsuccess', element: <FinancialSuccess /> },
      { path: 'morerelated', element: <MoreRelated /> },
      { path: 'favorites', element: <PrivateRoute><Favorites /></PrivateRoute> },
      { path: 'categorydetails', element: <CategoryDetails /> },
      { path: 'winterjacketshirt', element: <WinterjacketDetails /> },
      {path: 'offerstawqbreif',element:<OfferstawqBreif/>},
      {path:'terms',element:<Terms/>},

      //  {path:'offertawq',element:<OfferTawq/>},
      // { path:"register", element:<Register />} ,
      { path: 'productsfurniture', element: <ProductsFurniture /> },
      { path: 'productskitchen', element: <ProductsKitchen /> },
      { path: 'fsuccess', element: <FSuccess /> },
      { path: 'categoriesslider', element: <CategoriesSlider /> },
      { path: 'slider', element: <Slider /> },
      { path: 'abouttawq', element: <Abouttawq /> },
      { path: 'offers', element: <Offers /> },
      { path: "offerstawq", element: <OffersTawq /> },
      // {path:"offerstawqnajah",element:<Offerstawqnajah/>},
      { path: "successpartners", element: <SuccessPartners /> },
      { path: 'sellers', element: <Sellers /> },
      { path: 'sellersdetails/:id', element: <SellersDetails /> },
      { path: 'scrolltop', element: <ScrollTop /> },
      { path: 'alloffers', element: <AllOffers /> },
      { path: 'offerssugg', element: <OffersSugg /> },
      { path: 'offersdetails', element: <OffersDetails /> },
      { path: 'myaddvertisements', element: <Myaddvertisements /> },
      { path: 'cart', element: <Cart /> },
      { path: 'winterdetails', element: <WinterDetails /> },

      { path: '/products/:category', element: <AllProductsByCategory /> },
      { path: '/categoryProducts', element: <CategoryProducts /> },

      { path: 'privacy', element: <Privacy /> }

      , { path: '*', element: <Navigate to="/home" /> }

    ],
  },
  {
    path: "/seller",
    element: <SellerLayout />,
    children: [

      { index: true, element: <SellerHome /> },
      // { path: '/seller/sellerhome', element: <SellerHome /> },
      { path: 'sellerhome', element: <SellerHome /> },
      { path: '/seller/sellerlayout', element: <SellerLayout /> },
      { path: '/seller/sellerlogin', element: <SellerLogin /> },
      { path: '/seller/sellerneworders2', element: <SellerNewOrders2 /> },
      { path: '/seller/sellernewordersdetails/:id', element: <SellerNewordersDetails /> },
      { path: '/seller/sellerchangepassword', element: <SellerChangePassword /> },
      { path: '/seller/sellerforgetpassword', element: <SellerForgetPassword /> },
      { path: '/seller/sellerresetpassword', element: <SellerResetPassword /> },
      { path: '/seller/sellerregister', element: <SellerRegister /> },
      { path: '/seller/selleraccounttype', element: <SellerAccountType /> },
      { path: '/seller/sellerselleradmin', element: <SellerAdmin /> },
      { path: '/seller/sellerservices', element: <SellerServices /> },
      { path: '/seller/sellerrelatedproducts', element: <SellerRelatedProducts /> },
      { path: '/seller/SellerRelatedProductsWrapper', element: <SellerRelatedProductsWrapper /> },
      { path: '/seller/sellerrelatedactivites', element: <SellerRelatedActivites /> },
      { path: '/seller/sellersidebarfilters', element: <SellerSidebarFilters /> },
      { path: '/seller/sellerproductlist', element: <SellerProductList /> },
      { path: '/seller/sellerproductcard', element: <SellerProductCard /> },
      { path: '/seller/sellerproductdetails/:id', element: <SellerProductDetails /> },
      { path: '/seller/sellercanceledorders', element: <SellerCanceledOrders /> },
      { path: '/seller/sellerneworders', element: <SellerNewOrders /> },
      { path: '/seller/sellercanceledordersdetails/:id', element: <SellerCanceledOrdersDetails /> },
      { path: '/seller/selleraddadvertisement', element: <SellerAddAdvertisement /> },
      { path: '/seller/sellerfinancialreports', element: <SellerFinancialReports /> },
      { path: '/seller/sellermysecondstore', element: <SellerMysecodStore /> },
      { path: '/seller/selleradvertisementdetails/:id', element: <SellerAddverisementDetails /> },
      { path: '/seller/sellermyorders', element: <SellerMyOrders /> },
      { path: '/seller/sellerconfirmedorders', element: <SellerConfirmedOrders /> },
      { path: '/seller/sellerorderdetails', element: <SellerOrderDetails /> },
      { path: '/seller/sellershippedorders', element: <SellerShippedOrders /> },
      { path: '/seller/sellerordersdetails2', element: <SellerOrdersDetails2 /> },
      { path: '/seller/sellermyemptydeiveredorders', element: <SellerMyemptydeiveredOrders /> },
      { path: '/seller/sellermydeliveredorders', element: <SellerMydeliveredOrders /> },
      { path: '/seller/sellermarketing', element: <SellerMarketing /> },
      { path: '/seller/sellerprofileaccount', element: <SellerProfileAccount /> },
      { path: '/seller/sellermarketingreferral', element: <SellerMarketingReferral /> },
      { path: '/seller/sellerlogoutconfirm', element: <SellerLogoutConfirm /> },
      { path: '/seller/sellercontractpage', element: <SellerContractPage /> },
      { path: '/seller/sellersecondcontract', element: <SellerSecondContract /> },
      {path:'/seller/sellernotifications',element:<SellerNotifications/>},
      {path:'/seller/sellerstoredetails',element:<SellerStoreDetails/>},
     { path: '/seller/sellerconfirmedordersdetails/:id', element: <SellerConfirmdOrdersDetails /> },
      { path: '/seller/sellerbankaccount', element: <SellerBankAccount /> },
      { path: '/seller/selleremptyadvertisement', element: <SellerEmptyAdvertisement /> },
      { path: '/seller/sellerchoosesupport', element: <SellerChooseSupport /> },
      { path: '/seller/sellershippedordersdetails', element: <SellerShippedOrderDetails /> },
      { path: 'sellerproduct/:id', element: <SellerProductDetails /> },
      { path: '/seller/sellermaddisupport', element: <SellerMaddiSupport /> },
      { path: '/seller/selleraynisupport', element: <SellerAyniSupport /> },
      { path: '/seller/sellerotp', element: <SellerOtp /> },
      { path: '/seller/sellermystore', element: <SellerMyStore /> },
      { path: '/seller/selleresupport', element: <SellereSupport /> },
      { path: '/seller/sellerfinancialsupport', element: <SellerFinancialSupport /> },
      { path: '/seller/sellerprivacy', element: <SellerPrivacy /> },
      { path: '/seller/sellerterms', element: <SellerTerms /> },
      // {path:'/seller/sellerabout',element:<SellerAbout/>},
      { path: '/seller/sellerfooter', element: <SellerFooter /> },


      {
        path: "sellerrelatedproductsdetails/:id",
        element: <SellerRelatedProducts />
      },

      { path: '/seller/sellerdiscountsdetails', element: <SellerDiscountsDetails /> },
      { path: '/seller/sellermyorddetails', element: <SellerMyOrdDetails /> },
      { path: '/seller/sellerfinancialdashboard', element: <SellerFinancialDashboard /> },
      { path: '/seller/sellerproductsSection', element: <SellerProductsSection /> },
      { path: '/seller/sellermorerelated', element: <SellerMoreRelated /> },
      { path: '/seller/sellerabouttawq', element: <SellerAbouttawq /> },
      {path:'/seller/sellerreg2',element:<SellerReg2/>},
      // {path:'seller/winterjacketdetails',element:<WinterjacketDetails/>},
      { path: 'seller/sellerburgeroffer', element: <SellerBurgerOffer /> },
      { path: 'seller/sellermobileoffer', element: <SellerMobileOffer /> },
      { path: 'seller/sellerdiscountsdetails', element: <SellerDiscountsDetails /> },
      { path: "/seller/sellerburgeroffer", element: <SellerBurgerOffer /> },
      { path: "/seller/winterjacketdetails", element: <WinterjacketDetails /> },
      { path: "/seller/sellermobileoffer", element: <SellerMobileOffer /> },
      { path: "/seller/selleruppernav", element: <SellerUppernav /> }
    ],
  },
]);

function App() {
useEffect(() => {
  getMyToken();
  onMessage(messaging, (payload) => {
    console.log("📩 Message received:", payload);

    alert(
      payload.notification?.title + "\n" +
      payload.notification?.body
    );
  });
  onMessage(messaging, (payload) => {
  console.log("📩 Message:", payload);

  alert(payload.notification?.title); 
});
}, []);
  return (
    <>
    
      <RouterProvider router={router} />

      <ToastContainer
        position="top-right"
        autoClose={2000}
        theme="colored"
      />
      
    </>
  );
}

export default App;
